(function () {
  if(!document.querySelector(".year-content")) return this;

  document.getElementById('prev-year').addEventListener('click', function(event) {
    event.preventDefault(); // デフォルトのリンク動作を無効化
    
    var currentActive = document.querySelector('.year-content[data-scroll="in"]'); // 現在アクティブな年の要素を取得
    var prevYearElement = currentActive.nextElementSibling; // 前の年の要素を取得

    if (prevYearElement) {
      // 前の年の要素の位置に即座に移動する
      window.scrollTo({
        top: prevYearElement.offsetTop,
        behavior: 'auto' // 即座に移動する
      });
    }
  });

  // 次の年のリンクのクリックイベントリスナーを設定する
  document.getElementById('next-year').addEventListener('click', function(event) {
    event.preventDefault(); // デフォルトのリンク動作を無効化
    
    var currentActive = document.querySelector('.year-content[data-scroll="in"]'); // 現在アクティブな年の要素を取得
    var nextYearElement = currentActive.previousElementSibling; // 次の年の要素を取得

    if (nextYearElement) {
      // 次の年の要素の位置に即座に移動する
      window.scrollTo({
        top: nextYearElement.offsetTop,
        behavior: 'auto' // 即座に移動する
      });
    }
  });

  })();